import useThemeStore from './useThemeStore';

/**
 * 学生端主题覆盖
 * 在 init.ts 中判断为学生端后调用
 */
export default function studentTheme() {
  useThemeStore.setState({
    thinkDeeplyActiveIcon: 2,
    thinkDeeplyBtnColor: ' rgba(139, 92, 246, 1)',
    thinkDeeplyBtnBorder: '1px solid rgba(139, 92, 246, 0.08)',
    thinkDeeplyBtnBgColor: 'rgba(139, 92, 246, 0.1)',
    chatSendBtnBgColor: 'rgba(139, 92, 246, 1)',
    chatSendBtnBgHoverColor: 'rgba(111, 74, 197, 1)',

    bubbleListBottomFadeMaskBg: `linear-gradient(
                180deg,
                rgba(252, 251, 254, 0) 0%,
                rgba(252, 251, 254, 1) 100%
              )`,

    chatSenderLoadingBg: '#ffffff',
    chatSenderDisabledTextColor: 'rgba(37, 40, 43, 0.45)',
  });
}
